export const touchpointSourceKinds = [
    "sentMessage",
    "smsMessage",
    "voiceCall",
    "calendarEvent",
    "task",
];
export const touchpointKinds = ["email", "call", "text", "visit"];
export const touchpointTypes = [
    "visit",
    "call",
    "text",
    "email",
    "note",
    "event",
    "gift",
];
export const maxMyActivityRangeDays = 92;
//# sourceMappingURL=touchpoint.js.map